import PeopleIcon from './component.jsx'
export default PeopleIcon
